import { render, staticRenderFns } from "./ObjectButton.vue?vue&type=template&id=2d834c5d"
import script from "./ObjectButton.vue?vue&type=script&lang=js"
export * from "./ObjectButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports